import { render } from "./VendorServiceItem.vue?vue&type=template&id=39601972"
import script from "./VendorServiceItem.vue?vue&type=script&lang=js"
export * from "./VendorServiceItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__